export default __webpack_public_path__ + "static/SP-5defb3425e8fd35e8039f342274802d2.png";